import React from "react"
import axios from 'axios'
import { Box, Button, Card, Container, Divider, Typography } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"
import SaleStastics from "../components/OfflineShop/SaleStastics"
import ShopStocks from "../components/OfflineShop/ShopStocks"

function OfflineShops(props: any) {
  return (
    <Box>
      {/* <SaleStastics></SaleStastics> */}
      <ShopStocks></ShopStocks>
    </Box>
  )
}

export default OfflineShops